
import { usePlugin } from "./plugins";
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppFooter",
  setup() {
    const { popupPersonalPolicy } = usePlugin();

    const popupHowto = () => {
      window.open(
        "https://1drv.ms/w/s!Aq-p8jdGudbMl44E0yIONoNnmP-QJA?e=OTuoYR",
        "blank"
      );
    };
    return {
      popupPersonalPolicy,
      popupHowto,
    };
  },
});
